import { render, staticRenderFns } from "./shareSns.vue?vue&type=template&id=71103b2c&"
import script from "./shareSns.vue?vue&type=script&lang=js&"
export * from "./shareSns.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports